

const IPLTABConfig = {
    showIPLTab:false,
    iplUrl:"/betting-exchange/ipl",
    iplCompetitionId:"511"
}

export default IPLTABConfig;